import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Map } from 'immutable';
import appConfig from '../../appConfig';
import { validateSessionConnection } from '../../actions/session';
import {
  cancelAllRequests,
  createCategory,
  deleteCategory,
  editCategory,
  retrieveCategories,
  clearPanelTreeList,
  toggleCollectionCollapse,
  createRootCategory,
  createGlobalCategory,
} from '../../actions/categories';
import {
  deselectAll,
  retrieveCategory,
  retrieveSortUMOs,
} from '../../actions/umoGallery';
import {
  showCategoryMoveDialog,
  setMetaUmoId,
  toggleUMOSortView,
} from '../../actions/mainUI';
import PanelTree from '../PanelTree';
import CategoryDialog from '../CategoryDialog';
import { stringifiedToDraggable } from '../../utils/draggables';
import { isWorkbench } from '../../utils/piction';
import { showUploadTemplate } from '../../utils/uiUtils';
import { moveUmoHandler } from '../../utils/umoUtils';
import AddIcon from '../Icons/Add';
import AddSubCategoryIcon from '../Icons/AddSubCategoryDefault';
import EditIcon from '../Icons/EditDefaul';
import MoveIcon from '../Icons/MoveDefault';
import UploadIcon from '../Icons/UploadBlack';
import SortItemsIcon from '../Icons/SortItems';
import { addError } from '../../actions/messageDialog';

const mapStateToProps = (state) => ({
  categories: state.categories,
  session: state.session,
  mainUI: state.mainUI,
});

const mapDispatchToProps = (dispatch, state) => ({
  dispatch: (actionToDispatch) => dispatch(actionToDispatch),
  onCategoryClick: (categoryID, label, description, search) => {
    dispatch(setMetaUmoId(null));
    dispatch(deselectAll());
    dispatch(retrieveCategory(categoryID, label, description, search));
  },
  onEditSubmit: (categoryID, categoryName) =>
    dispatch(editCategory(categoryID, categoryName)),
  onCreateSubmit: (categoryParentID, categoryName, collectionID) =>
    dispatch(createCategory(categoryName, categoryParentID, collectionID)),
  onCreateRootSubmit: (categoryName, collectionID) =>
    dispatch(createRootCategory(categoryName, 0, collectionID)),
  onShowUploadTemplate: (categoryID, categoryName) =>
    showUploadTemplate(dispatch, categoryID, categoryName),
  dispatchErrorMessage: (message) => dispatch(addError(message)),
  onDeleteSubmit: (categoryID) => dispatch(deleteCategory(categoryID)),
  retrieveCategories: (categoryID) => dispatch(retrieveCategories(categoryID)),
  clearPanelTreeList: (categoryID) => dispatch(clearPanelTreeList(categoryID)),
  toggleCollectionCollapse: (collID) =>
    dispatch(toggleCollectionCollapse(collID)),
  cancelAllRequests: () => dispatch(cancelAllRequests()),
  showCategoryMoveDialog: (categoryID, categoryName) =>
    dispatch(showCategoryMoveDialog(categoryID, categoryName)),
  validateSession: (surl) => dispatch(validateSessionConnection(surl)),
  toggleUMOSort: (categoryID, categoryName) => {
    dispatch(retrieveSortUMOs(categoryID, categoryName));
    dispatch(toggleUMOSortView(true));
  },
  onCreateGlobalSubmit: (categoryName, collectionID) =>
    dispatch(createGlobalCategory(categoryName, collectionID)),
});

class NavCategoryPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCategoryDialogShown: false,
      isEdit: false,
      selectedCategoryData: null,
    };

    this.onEditSelect = this.onEditSelect.bind(this);
    this.onCategoryDialogToggle = this.onCategoryDialogToggle.bind(this);
    this.onCategoryCreateClick = this.onCategoryCreateClick.bind(this);
    this.onGlobalCategoryCreateClick =
      this.onGlobalCategoryCreateClick.bind(this);
    this.onPanelItemDrop = this.onPanelItemDrop.bind(this);
    this.getCategoryOptions = this.getCategoryOptions.bind(this);
  }

  componentDidMount() {
    // this.props.retrieveCategories();
    if (this.props.categories.get('categoryList').size === 0)
      this.props.retrieveCategories();
  }

  componentWillUnmount() {
    this.props.cancelAllRequests();
  }

  onEditSelect(key, workspaceID, workspaceName, collectionID) {
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        switch (key) {
          case 'edit':
            this.setState({
              isCategoryDialogShown: true,
              isEdit: true,
              selectedCategoryData: {
                id: workspaceID,
                name: workspaceName,
                collectionID,
              },
            });
            break;
          case 'subCategory':
            this.onCategoryCreateClick(
              null,
              workspaceID,
              workspaceName,
              collectionID
            );
            break;
          case 'upload':
            if (this.props.mainUI.getIn(['fileUploader', 'isUploading']))
              this.props.dispatchErrorMessage(
                this.props.intl.formatMessage({
                  id: 'fileUploader.uploadInProgressMessage',
                })
              );
            else this.props.onShowUploadTemplate(workspaceID, workspaceName);
            break;
          case 'move':
            this.props.showCategoryMoveDialog(workspaceID, workspaceName);
            break;
          case 'sort':
            this.props.toggleUMOSort(workspaceID, workspaceName);
            break;
          default:
            break;
        }
      }
      return null;
    });
  }

  onCategoryDialogToggle(toggle) {
    this.setState({
      isCategoryDialogShown: toggle,
    });
  }

  onCategoryCreateClick(
    e,
    categoryParentID,
    categoryName,
    collectionID,
    categorySearch
  ) {
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        this.setState({
          isCategoryDialogShown: true,
          isEdit: false,
          selectedCategoryData: categoryParentID
            ? {
                id: categoryParentID,
                name: categoryName,
                collectionID,
                search: categorySearch,
              }
            : null,
        });
      }
    });
  }

  onGlobalCategoryCreateClick(e) {
    // get Collection ID of CC to create a global category
    const collectionID = this.props.categories
      .get('categoryList')
      .find((cat) => cat.get('t') === 'CC')
      .get('i');

    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        this.setState({
          isCategoryDialogShown: true,
          isEdit: false,
          selectedCategoryData: {
            id: '0',
            name: '',
            collectionID,
            isGlobal: true,
          },
        });
      }
    });
  }

  onPanelItemDrop(e, categoryID, isCopy, isEditable) {
    e.preventDefault();
    $('.main__search-bar').removeAttr('style');
    const draggable = stringifiedToDraggable(e.dataTransfer.getData('text'));
    const origin = {
      id: draggable.originData.workspaceID,
      isWorkspace: draggable.isWorkspaceItem(),
      categoryID: draggable.getCategoryID(),
    };
    const target = {
      id: categoryID,
      isWorkspace: false,
      editable: isEditable,
    };
    moveUmoHandler(
      origin,
      target,
      draggable.getSelectionList(),
      this.props.dispatch,
      draggable.getIsSelectAll() ? draggable.getSearchParams() : null,
      isCopy
    );
  }

  getCategoryOptions() {
    let editOptions;
    const intl = this.props.intl;
    if (appConfig.menuOptions.categorySpannerMenu) {
      if (appConfig.menuOptions.categorySpannerMenu.length > 0) {
        const menuOptions = appConfig.menuOptions.categorySpannerMenu;
        editOptions = [];
        menuOptions.forEach((value) => {
          switch (value) {
            case 'subCategory':
              editOptions.push({
                eventKey: 'subCategory',
                icon: <AddSubCategoryIcon />,
                label: intl.formatMessage({
                  id: 'navCategoryPanel.menuAddChild',
                }),
              });
              break;
            case 'upload':
              editOptions.push({
                eventKey: 'upload',
                icon: <UploadIcon />,
                label: intl.formatMessage({
                  id: 'navCategoryPanel.menuUploadToChild',
                }),
              });
              break;
            case 'edit':
              editOptions.push({
                eventKey: 'edit',
                icon: <EditIcon />,
                label: intl.formatMessage({
                  id: 'navCategoryPanel.menuEditChild',
                }),
              });
              break;
            case 'move':
              editOptions.push({
                eventKey: 'move',
                icon: <MoveIcon />,
                label: intl.formatMessage({
                  id: 'navCategoryPanel.menuMoveChild',
                }),
              });
              break;
            case 'sort':
              editOptions.push({
                eventKey: 'sort',
                icon: <SortItemsIcon />,
                label: intl.formatMessage({
                  id: 'navCategoryPanel.menuSortChild',
                }),
              });
              break;
            default:
              break;
          }
        });
      }
    } else if (isWorkbench()) {
      // backwards support for appConfigs without the new definition
      editOptions = [
        {
          eventKey: 'subCategory',
          icon: <AddSubCategoryIcon />,
          label: intl.formatMessage({ id: 'navCategoryPanel.menuAddChild' }),
        },
        {
          eventKey: 'upload',
          icon: <UploadIcon />,
          label: intl.formatMessage({
            id: 'navCategoryPanel.menuUploadToChild',
          }),
        },
        {
          eventKey: 'edit',
          icon: <EditIcon />,
          label: intl.formatMessage({ id: 'navCategoryPanel.menuEditChild' }),
        },
        {
          eventKey: 'move',
          icon: <MoveIcon />,
          label: intl.formatMessage({ id: 'navCategoryPanel.menuMoveChild' }),
        },
      ];
      if (appConfig.enableSortCategory)
        editOptions.push({
          eventKey: 'sort',
          icon: <SortItemsIcon />,
          label: intl.formatMessage({ id: 'navCategoryPanel.menuSortChild' }),
        });
    }
    return editOptions;
  }

  render() {
    const editOptions = this.getCategoryOptions();
    return (
      <div className="nav-content__body">
        <h2
          className={cn('nav-content__title', {
            'nav-content__title--with-sub': isWorkbench(),
          })}
        >
          {this.props.intl.formatMessage({
            id: 'navCategoryPanel.categoryHeader',
          })}
        </h2>
        {appConfig.enableGlobalCategoryCreation ? (
          <div
            onClick={this.onGlobalCategoryCreateClick}
            className="nav-content__body__addBtn"
          >
            <AddIcon stroke="#fff" width={20} height={20} />
            &nbsp;
            {this.props.intl.formatMessage({
              id: 'navCategoryPanel.createGlobalCategoryBtn',
            })}
          </div>
        ) : null}
        <PanelTree
          onPanelItemClick={this.props.onCategoryClick}
          onPanelItemDrop={isWorkbench() ? this.onPanelItemDrop : undefined}
          retrievePanelTreeList={this.props.retrieveCategories}
          panelTreeList={this.props.categories.get('categoryList')}
          retrieveChildrenRequests={this.props.categories.get(
            'retrieveChildrenRequests'
          )}
          clearPanelTreeList={this.props.clearPanelTreeList}
          toggleCollectionCollapse={this.props.toggleCollectionCollapse}
          onEditSelect={isWorkbench() ? this.onEditSelect : undefined}
          editOptions={editOptions}
          isRoot
          isRetrievingRoot={this.props.categories.get('isRetrievingRoot')}
          showContentCount={appConfig.categoryCounts}
        />
        <CategoryDialog
          isCategoryDialogShown={this.state.isCategoryDialogShown}
          onCategoryDialogToggle={this.onCategoryDialogToggle}
          selectedCategoryData={this.state.selectedCategoryData}
          isEdit={this.state.isEdit}
          editRequests={this.props.categories.get('editRequests')}
          createRequests={this.props.categories.get('createRequests')}
          onEditSubmit={this.props.onEditSubmit}
          onCreateSubmit={this.props.onCreateSubmit}
          onCreateRootSubmit={this.props.onCreateRootSubmit}
          onCreateGlobalSubmit={this.props.onCreateGlobalSubmit}
          onDeleteSubmit={this.props.onDeleteSubmit}
        />
      </div>
    );
  }
}

NavCategoryPanel.propTypes = {
  cancelAllRequests: PropTypes.func,
  categories: PropTypes.instanceOf(Map),
  session: PropTypes.instanceOf(Map),
  onCategoryClick: PropTypes.func,
  retrieveCategories: PropTypes.func,
  clearPanelTreeList: PropTypes.func,
  toggleCollectionCollapse: PropTypes.func,
  onEditSubmit: PropTypes.func,
  onDeleteSubmit: PropTypes.func,
  onCreateSubmit: PropTypes.func,
  onCreateRootSubmit: PropTypes.func,
  showCategoryMoveDialog: PropTypes.func,
  onShowUploadTemplate: PropTypes.func,
  validateSession: PropTypes.func,
  dispatch: PropTypes.func,
  toggleUMOSort: PropTypes.func,
  onCreateGlobalSubmit: PropTypes.func,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(NavCategoryPanel)
);
